import { Navigator } from "../../main_components/navigator.js";
import { ErrorNotAvailable } from "../../main_components/error_message.js";
import Styles from "./shorts.module.css";
import errorNotAvailable from "../../images/Process-cuate.png";
export const ShortsBody = ( props ) => {
    const {  } = props;
    const { Body, Content } = Styles;
    const headlines = [
        "🚧 Oops! This page is on its way! ⏳",
        "🚧 Hang tight! This page will be here soon! ⏳",
        "🚧 Coming soon! Check back later! ⏳",
        "🚧 Almost ready! Stay tuned! ⏳",
        "🚧 Oops! We’re building this page! ⏳",
        "🚧 Just a moment! This page is in progress! ⏳",
        "🚧 Page in the works! Thanks for your patience! ⏳"
    ];
    return (
        <main className={ Body }>
            <Navigator page={ "Shorts" }/>
            <main className={ Content }>
                <ErrorNotAvailable image={ errorNotAvailable } headlines={ headlines }/>
            </main>
        </main>
    );
};